/**
 * Tiny synchronous event bus. Feature modules never import each other; they talk
 * through here. Handlers run in registration order and exceptions are contained so
 * one bad listener can't stall a frame.
 */
export class Events {
  constructor() {
    this.map = new Map();
  }

  on(name, fn) {
    let list = this.map.get(name);
    if (!list) this.map.set(name, (list = []));
    list.push(fn);
    return () => this.off(name, fn);
  }

  once(name, fn) {
    const off = this.on(name, (payload) => {
      off();
      fn(payload);
    });
    return off;
  }

  off(name, fn) {
    const list = this.map.get(name);
    if (!list) return;
    const i = list.indexOf(fn);
    if (i !== -1) list.splice(i, 1);
  }

  emit(name, payload) {
    const list = this.map.get(name);
    if (!list) return;
    // Iterate a copy: handlers are allowed to unsubscribe themselves.
    for (const fn of list.slice()) {
      try {
        fn(payload);
      } catch (err) {
        console.error(`[events] handler for "${name}" threw`, err);
      }
    }
  }

  clear() {
    this.map.clear();
  }
}
